import { Heart } from "lucide-react";
import RecipeCard from "@/components/app/RecipeCard";

export default function FavoritesTab({ favorites, onOpen, isFav, toggleFav }) {
  return (
    <div data-testid="favorites-tab">
      <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight">I tuoi preferiti</h1>
      {favorites.length === 0 ? (
        <div className="mt-10 flex flex-col items-center text-center text-[#4F5D52] gap-3 py-16" data-testid="favorites-empty">
          <Heart className="h-10 w-10 text-[#D95338]" strokeWidth={1.5} />
          <p>Nessuna ricetta salvata. Tocca il cuore su una ricetta per tenerla qui.</p>
        </div>
      ) : (
        <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {favorites.map((f, i) => <RecipeCard key={f.recipe.id} recipe={f.recipe} index={i} onOpen={onOpen} fav={isFav(f.recipe)} onFav={toggleFav} />)}
        </div>
      )}
    </div>
  );
}
